<div class="routers" [formGroup]="form">
  @for (router of mbbRouters; track router.offeringId) {
    @if (getCorrelatedBundle(router, mbbProduct.mbbSubscription.id); as correlatedBundle) {
      <app-ice-select-box
        radioTestId="mbb-router-input"
        [control]="form.controls.mbbRouter"
        [disabled]="disableRouter(router)"
        [label]="router.name"
        [value]="router.offeringId"
      >
        @if (mbbProduct.mbbSubscription.id && canSellHardwareWithLogistics()) {
          <div class="heading" inlineHeaderContent>
            {{ correlatedBundle.hardwarePrice | priceFormat: PriceType.OneTime }}
          </div>
        }
        <div class="router-row" header>
          <div class="image-container">
            <img [alt]="router.name" [src]="router.image ? router.image.downloadUri : imageAssets.mbb_illustration" />
          </div>
          <div class="router-details">
            <ng-container *appAllowSettings="[DealerClaimType.CanSellHardwareWithLogistics]">
              @if (warehouseState.quantityInStock[router.offeringId] !== undefined) {
                <span class="stock-info-text">
                  {{
                    warehouseState.quantityInStock[router.offeringId] > 20
                      ? '20+'
                      : warehouseState.quantityInStock[router.offeringId] || 'Ingen'
                  }}
                  på lager
                </span>
              } @else {
                <app-spinner align="left" />
              }
            </ng-container>
          </div>
        </div>
      </app-ice-select-box>
    }
  }
</div>
